import axios from 'axios';

interface IApiClientFactory {
  addToCart: (productId: string) => Promise<void>;
  addToWishlist: (productId: string) => Promise<void>;
  removeFromWishlist: (productId: string) => Promise<void>;
}

export const apiClientFactory = ({
  apiUrl,
}: {
  apiUrl: string;
}): IApiClientFactory => {
  const client = axios.create({
    baseURL: apiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return {
    addToCart: async (productId: string) => {
      const apiUri = '/cart/add';

      const requestBody = {
        productId,
      };

      try {
        const response = await client.post(apiUri, requestBody, {
          maxRedirects: 0,
          validateStatus: (statusCode) => {
            return statusCode >= 200 && statusCode < 400;
          },
        });

        if (response.status >= 400) {
          // eslint-disable-next-line no-console
          console.log(
            `Unable to add to cart. Response: ${response.statusText}}. Request: ${apiUri}`
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(
          `Unable to add to cart. Error: ${
            (error as Error)?.message
          }}. Request: ${apiUri}`
        );
      }
    },
    addToWishlist: async (productId: string) => {
      const apiUri = `/wishlist/${productId}`;

      try {
        const response = await client.post(apiUri, null, {
          maxRedirects: 0,
          validateStatus: (statusCode) => {
            return statusCode >= 200 && statusCode < 400;
          },
        });
        if (response.status >= 400) {
          // eslint-disable-next-line no-console
          console.log(
            `Unable to add to wishlist. Response: ${response.statusText}}. Request: ${apiUri}`
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(
          `Unable to add to wishlist. Error: ${
            (error as Error)?.message
          }}. Request: ${apiUri}`
        );
      }
    },
    removeFromWishlist: async (productId: string) => {
      const apiUri = `/wishlist/${productId}`;

      try {
        const response = await client.delete(apiUri, {
          maxRedirects: 0,
          validateStatus: (statusCode) => {
            return statusCode >= 200 && statusCode < 400;
          },
        });
        if (response.status >= 400) {
          // eslint-disable-next-line no-console
          console.log(
            `Unable to remove from wishlist. Response: ${response.statusText}}. Request: ${apiUri}`
          );
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(
          `Unable to remove from wishlist. Error: ${
            (error as Error)?.message
          }}. Request: ${apiUri}`
        );
      }
    },
  };
};
